/* Home "Buy any 2 for $99" card: rotates its example pairs. Packshots crossfade and the price math under the
   title follows the same pair. Runs only while the card is on screen and the tab is visible; pauses on hover,
   keyboard focus and via its own button; never moves on its own under prefers-reduced-motion. */
(() => {
  if (window.HumblerOfferRotator) return;
  window.HumblerOfferRotator = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const loadImages = slide => {
    slide?.querySelectorAll('img[data-hb-src]').forEach(img => {
      if (img.dataset.hbSrcset) img.srcset = img.dataset.hbSrcset;
      img.src = img.dataset.hbSrc;
      img.removeAttribute('data-hb-src');
      img.removeAttribute('data-hb-srcset');
    });
  };

  const init = card => {
    if (card.dataset.hbRotatorReady) return;
    const slides = [...card.querySelectorAll('[data-hb-pair-slide]')];
    const maths = [...card.querySelectorAll('[data-hb-pair-math]')];
    if (slides.length < 2 || slides.length !== maths.length) return;
    card.dataset.hbRotatorReady = 'true';

    const media = card.querySelector('[data-hb-pair-media]');
    const pause = card.querySelector('[data-hb-pair-pause]');
    const progress = card.querySelector('.hb-home-offer__progress');
    const interval = Math.max(2500, Number(card.dataset.interval) || 4000);
    let index = 0;
    let timer = null;
    let visible = false;
    let hovered = false;
    let pinned = false; // paused with the button

    media.classList.add('is-rotating');
    media.style.setProperty('--hb-pair-interval', `${interval}ms`);
    if (pause) pause.hidden = false;
    if (progress) progress.hidden = false;

    const show = next => {
      index = (next + slides.length) % slides.length;
      loadImages(slides[index]);
      loadImages(slides[(index + 1) % slides.length]); // warm the next pair
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      maths.forEach((math, i) => {
        math.classList.toggle('is-active', i === index);
        math.setAttribute('aria-hidden', String(i !== index));
      });
    };

    const running = () => visible && !hovered && !pinned && !document.hidden && !reduceMotion.matches;
    const restartBar = () => {
      if (!progress) return;
      progress.classList.remove('is-filling');
      void progress.offsetWidth; // restart the CSS fill
      if (running()) progress.classList.add('is-filling');
    };
    const sync = () => {
      clearInterval(timer);
      timer = null;
      card.classList.toggle('is-paused', !running());
      if (running()) {
        timer = setInterval(() => { show(index + 1); restartBar(); }, interval);
        restartBar();
      } else {
        progress?.classList.remove('is-filling');
      }
    };

    show(0);
    // Keep a reference: an unreferenced observer can be garbage-collected before it ever reports.
    const observer = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting);
      sync();
    }, { threshold: .4 });
    observer.observe(card);
    card.hbRotatorObserver = observer;
    // Fallback if the first observer callback is late: measure once.
    setTimeout(() => {
      if (visible) return;
      const box = card.getBoundingClientRect();
      visible = box.bottom > 0 && box.top < window.innerHeight;
      sync();
    }, 1200);
    card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; sync(); } });
    card.addEventListener('pointerleave', () => { hovered = false; sync(); });
    card.addEventListener('focusin', () => { hovered = true; sync(); });
    card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget)) { hovered = false; sync(); } });
    document.addEventListener('visibilitychange', sync);
    reduceMotion.addEventListener('change', sync);
    pause?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      pinned = !pinned;
      // Fixed label ("Pause example pairs") + aria-pressed, like the announcement bar's pause button.
      pause.setAttribute('aria-pressed', String(pinned));
      if (!pinned) show(index + 1);
      sync();
    });
  };

  const scan = (root = document) => root.querySelectorAll('[data-hb-pair-rotator]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
